import NewOrderNotification from './NewOrderNotification';

export default NewOrderNotification;
